import React, { useEffect, useState } from 'react';
import attractionImg from '../Assest/download.jpeg';
import brainwavesImg from '../Assest/download (1).jpeg';
import VisualizationImg from '../Assest/download (2).jpeg';
import EmotionalImg from '../Assest/download (3).jpeg';
import IntentionsImg from '../Assest/download (4).jpeg';
import ReprogramImg from '../Assest/download (5).jpeg';

const cards = [
  {
    title: "The Law of Attraction Decoded 🔥",
    text: <>तुमचे विचार, भाव-भावना आणि actions कसे align करून abundance कसं attract करायचं हे समजून घ्या. हे फक्त belief नाही, तर शास्त्र आहे.</>,
    img: attractionImg
  },
  {
    title: "Brainwaves चं Science 🔥",
    text: <>वेगवेगळ्या brainwaves कशा तुमच्या manifestation ability ला <br />वाढवतात हे समजून घ्या. हे तुम्हाला focus आणि creativity amplify करायला मदत करेल.</>,
    img: brainwavesImg
  },
  {
    title: "Visualization Mastery 🔥",
    text: <>Visualization techniques शिकून तुमच्या deepest desires चं actualization कसं करायचं ते जाणून घ्या. तुम्हाला हे शिकायला मिळेल की तुमचं brain imagination आणि reality मधला फरक ओळखत नाही—याचा फायदा कसा घ्यायचा ते समजून घ्या.</>,
    img: VisualizationImg
  },
  {
    title: "Emotional Alignment 🔥",
    text: <>Manifestation फक्त विचार करण्याबद्दल नाही, तर तुम्ही कोणत्या भावनांमध्ये आहात ते देखील महत्वाचं आहे. तुमच्या desires शी align होणाऱ्या भावना कशा निर्माण करायच्या हे जाणून घ्या.</>,
    img: EmotionalImg
  },
  {
    title: "Set Intentions with Precision 🔥",
    text: <>Intentions कसे सेट करायचे आणि त्यात success<br /> मिळवायचं हे शिकून घ्या.</>,
    img: IntentionsImg
  },
  {
    title: "Reprogram Subconscious Mind 🔥",
    text: <>तुमचे जुने limiting beliefs बदलून नवीन empowering beliefs कसे सेट करायचे ते शिकून घ्या.</>,
    img: ReprogramImg
  }
];

const WorkshopCards = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <>
      <div style={{ background: 'linear-gradient(180deg, #000b3e 0, #020202 59%)', color: '#fff', textAlign: 'center', padding: '60px 20px' }}>
        <h2 style={{
          fontSize: '28px',
          color: '#fff',
          marginBottom: '40px',
          lineHeight: '1.4',
          fontFamily: 'Outfit, sans-serif'
        }}>
          या <b>2-day workshop</b> नंतर तुमचं life कसं बदलणार आहे, हे तुम्ही स्वतः <br />अनुभवाल!
        </h2>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '30px',
          flexWrap: 'wrap'
        }}>
          {cards.map((card, idx) => (
            <div key={idx} style={{
              background: '#fff',
              color: '#000',
              width: '400px',
              borderRadius: '10px',
              boxShadow: '0px 0px 30px rgba(255, 191, 0, 0.4)',
              padding: '20px',
              textAlign: 'center'
            }}>
              <div style={{
                width: '120px',
                height: '120px',
                margin: '0 auto 20px',
                borderRadius: '50%',
                overflow: 'hidden',
                border: '3px solid #f5c542'
              }}>
                <img src={card.img} alt="icon" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <h3 style={{
                fontSize: '18px',
                marginBottom: '10px',
                fontWeight: 'bold',
                fontFamily: 'DM Sans,sans-serif',
                color: '#3B3B3B',
              }}>{card.title}</h3>
              <p style={{
                fontSize: '14px',
                lineHeight: '1.5',
                fontFamily: 'DM Sans,sans-serif',
                color: '#3B3B3B',
                fontWeight: 'bold'
              }}>{card.text}</p>
            </div>
          ))}
        </div>

        {/* TEXT SECTION BELOW */}
        <div style={{
          textAlign: 'center',
          padding: '40px 20px 10px',
          fontFamily: 'Outfit, sans-serif',
          color: '#fff'
        }}>
          <p style={{ margin: '20px auto', maxWidth: '800px', lineHeight: '1.6' }}>
            या workshop मध्ये दिलेल्या techniques सर्वांसाठी simple आणि effective आहेत.
          </p>
          <hr style={{ width: '300px', margin: '20px auto', borderColor: '#fff' }} />
          <p style={{ margin: '20px auto', maxWidth: '800px', lineHeight: '1.6' }}>
            20,000+ participants ने या proven manifestation methods ने आपलं जीवन बदललं आहे.
          </p>
          <hr style={{ width: '300px', margin: '20px auto', borderColor: '#fff' }} />
          <p style={{ margin: '20px auto', maxWidth: '800px', lineHeight: '1.6' }}>
            तुम्हाला manifestation बद्दल काहीच माहिती नसली तरी चालेल—start करा जिथून तुम्ही आहात आणि results बघा.
          </p>
          <hr style={{ width: '300px', margin: '20px auto', borderColor: '#fff' }} />
          <p style={{ margin: '20px auto', maxWidth: '800px', lineHeight: '1.6' }}>
            कोणालाही special tools किंवा rituals ची गरज नाही—just open mind आणि शिकण्याची इच्छा पुरेशी आहे.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <button style={{
            background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
            color: 'white',
            fontSize: isMobile ? '18px' : '20px',
            padding: isMobile ? '10px 40px' : '25px 80px',
            border: 'none',
            borderRadius: '20px',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: isMobile ? '100%' : 'auto',
          }}>
            Join The 2 Day Workshop for ₹199 &nbsp;
            <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹999</span>
          </button>
          <p style={{
            marginTop: '10px',
            color: 'white',
            fontSize: '16px',
            fontFamily: 'outfit,sans-serif',
            fontStyle: 'italic'
          }}>
            Registrations End on <span style={{ fontWeight: 'bold', color: 'red' }}>11 JUL</span> <br />
            100% मनी बॅक गॅरंटी | समाधानी नसल्यास
          </p>
        </div>
      </div>
    </>
  );
};

export default WorkshopCards;
